import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LoaderModule } from '../loader';
import { OverlayModule } from '../overlay';
import { SpinnerOverlayComponent } from './spinner-overlay.component';

@NgModule({
  imports: [
    CommonModule,
    LoaderModule,
    OverlayModule
  ],
  declarations: [
    SpinnerOverlayComponent
  ],
  exports: [
    SpinnerOverlayComponent
  ]
})
export class SpinnerOverlayModule {
}
